export enum ExpenseType {
  normal,
  planned,
}
